<template>
  <aside
    :class="['main-sidebar', 'col-12', 'col-md-3', 'col-lg-2', 'px-0', sidebarVisible ? 'open' : '']"
  >
    <div class="main-navbar">
      <nav
        class="navbar align-items-stretch navbar-light bg-white flex-md-nowrap border-bottom p-0"
      >
        <d-link
          class="navbar-brand w-100 mr-0"
          :to="{ name: 'landing' }"
          style="line-height: 25px;"
        >
          <div class="d-table m-auto">
            <img
              id="main-logo"
              class="d-inline-block align-top mr-1"
              style="width: 80px; margin-top: 4px;"
              src="@/assets/images/spring-logo.svg"
              alt="Spring.app"
            />
          </div>
        </d-link>
        <a class="toggle-sidebar d-sm-inline d-md-none d-lg-none" @click="handleToggleSidebar()">
          <i class="material-icons">&#xE5C4;</i>
        </a>
      </nav>
    </div>
    <!-- Sidebar Items -->
    <div class="nav-wrapper">
      <d-nav class="nav--no-borders flex-column cursor">
        <li class="nav-item dropdown">
          <d-link class="nav-link" to="/analytics">
            <div class="item-icon-wrapper">
              <i class="material-icons">&#xE917;</i>
            </div>
            <span>{{ $t("sidebar.dashboard") }}</span>
          </d-link>
        </li>

        <li class="nav-item dropdown">
          <d-link class="nav-link" to="/campaigns">
            <div class="item-icon-wrapper">
              <i class="material-icons">&#xE8E1;</i>
            </div>
            <span>{{ $t("sidebar.campaigns") }}</span>
          </d-link>
        </li>

        <li class="nav-item dropdown">
          <d-link class="nav-link" to="/edit-user-profile">
            <div class="item-icon-wrapper">
              <i class="material-icons">&#xE7FD;</i>
            </div>
            <span>{{ $t("sidebar.account") }}</span>
          </d-link>
        </li>

        <li class="nav-item dropdown">
          <div class="nav-link" @click="navigatePlan()">
            <div class="item-icon-wrapper">
              <i class="material-icons">&#xe870;</i>
            </div>
            <span>{{ $t("sidebar.plan") }}</span>
          </div>
        </li>

        <!-- <li class="nav-item dropdown">
          <d-link class="nav-link" to="/social-inbox">
            <div class="item-icon-wrapper">
              <i class="material-icons">&#xe0b7;</i>
            </div>
            <span>{{ $t("sidebar.inbox") }}</span>
          </d-link>
        </li>

        <li class="nav-item dropdown">
          <d-link class="nav-link" to="/leads">
            <div class="item-icon-wrapper">
              <i class="material-icons">&#xE7Fb;</i>
            </div>
            <span>{{ $t("sidebar.manageleads") }}</span>
          </d-link>
        </li>

        <li class="nav-item dropdown">
          <d-link class="nav-link" to="/tips">
            <div class="item-icon-wrapper">
              <i class="material-icons">&#xe6dd;</i>
            </div>
            <span>{{ $t("sidebar.tips") }}</span>
          </d-link>
        </li>-->

        <!-- <li class="nav-item dropdown">
          <d-link class="nav-link" to="/team">
            <div class="item-icon-wrapper">
              <i class="material-icons">&#xE7Fb;</i>
            </div>
            <span>{{ $t("sidebar.team") }}</span>
          </d-link>
        </li>-->
      </d-nav>
    </div>
  </aside>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "main-sidebar",
  props: {
    /**
     * Whether to hide the logo text, or not.
     */
    hideLogoText: {
      type: Boolean,
      default: false
    },
    /**
     * The menu items.
     */
    items: {
      type: Array,
      required: false
    }
  },
  computed: {
    ...mapGetters(["getCurrentUser"])
  },
  data() {
    return {
      sidebarVisible: false
    };
  },
  created() {
    this.$eventHub.$on("toggle-sidebar", this.handleToggleSidebar);
  },
  beforeDestroy() {
    this.$eventHub.$off("toggle-sidebar");
  },
  methods: {
    handleToggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    },
    navigatePlan() {
      if (this.getCurrentUser.premium) {
        this.$router.push({ name: "pro-plan" });
      } else {
        this.$router.push({ name: "plan" });
      }
    }
  }
};
</script>

<style lang="scss">
.main-sidebar {
  .item-icon-wrapper {
    display: inline-block;
  }
  .dropdown-menu {
    display: block;
  }
}
</style>
